import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setApiStore } from "@/lib/api";

const StoreCtx = createContext(null);
const KEY = "kt_active_store";

export function StoreProvider({ children }) {
  const [state, setState] = useState({ loading: true, stores: [], active: null, multiTenant: false, error: null });
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    let alive = true;
    api.get("/me/stores").then(({ data }) => {
      if (!alive) return;
      const stores = data.stores || [];
      const saved = sessionStorage.getItem(KEY);
      const id = stores.some((s) => s.store_id === saved) ? saved : data.active_store_id;
      const active = stores.find((s) => s.store_id === id) || null;
      if (data.multi_tenant_enabled) setApiStore(active?.store_id);
      if (active) sessionStorage.setItem(KEY, active.store_id);
      setState({ loading: false, stores, active, multiTenant: !!data.multi_tenant_enabled, error: null });
    }).catch((e) => {
      if (alive) setState((s) => ({ ...s, loading: false, error: e.response?.data?.detail || "Unable to load stores" }));
    });
    return () => { alive = false; };
  }, []);

  const switchStore = useCallback(async (storeId) => {
    const target = state.stores.find((s) => s.store_id === storeId);
    if (!target) return;
    await api.post("/me/active-store", { store_id: storeId });
    sessionStorage.setItem(KEY, storeId);
    setApiStore(storeId);
    setCartCount(0);
    setState((s) => ({ ...s, active: target }));
  }, [state.stores]);

  return (
    <StoreCtx.Provider value={{ ...state, switchStore, cartCount, setCartCount }}>
      {children}
    </StoreCtx.Provider>
  );
}

export const useStore = () => useContext(StoreCtx);
